<template>
  <div>
    <b-modal :id="modalName" size="lg" hide-footer :title="(isUpdate ? 'Modification' : 'Ajout') + ' d\'une Marque'">
      <b-form class="marque-add" @submit.prevent="onSubmit">
        <b-row>
          <b-col>
            <blinki-input-txt v-model="marque.nom" :disabled="marqueRole" type="alphabet"
                              class="my-2" id="nom" label="nom" placeholder="Nom marque" module="marque" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <blinki-input-txt :max="5000" v-model="marque.titre" type="text"
                              class="my-2" id="titre" label="titre" placeholder="Titre" module="marque" />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <label class="label">Image :</label>
          </b-col>
          <b-col>
            <label class="label">Description<span class="text-danger m-0">(*)</span> :</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <blinkiUpload
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
              @edit-image="editImage"
              :data-images="images"
              :multiple="false"
              markIsPrimaryText="Défini comme principal"
              primaryText="Image principale"
              browseText="Ajouter une image"
              dragText="Glisser l'image ici"
              dropText="Déposer l'image"
              class="image-upload"
              :showDelete="false"
            ></blinkiUpload>
          </b-col>
          <b-col>
            <b-textarea required class="h-100" :rows="8" v-model="marque.description" ></b-textarea>
          </b-col>
          <template v-if="marque.delivery_modes">
            <b-col cols="12">
              <div class="w-100 h-100 overflow-auto" style="max-height: 400px">
                <livraison-mode v-for="mode in marque.delivery_modes" :mode="mode" :key="mode.livraison_mode_id" :hide-option="true" ></livraison-mode>
              </div>
            </b-col>
          </template>
        </b-row>
        <save-btn-container class="mt-2" :modal_name="modalName" :valid="isFormValid" />
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import formFile from '~/components/template/form/blinki-input-file';
import blinkiInputTxt from '~/components/template/form/blinki-input-txt';
import saveBtnContainer from '~/components/popups/save-btn-container';
import customSelect from '~/components/template/form/custom-select';
import {ITEM_TYPES as item_types} from '~/api/variables.js';
import {VueEditor} from "vue2-editor";
import {mapGetters} from 'vuex'
import VueUploadMultipleImage from 'vue-upload-multiple-image';
import {getLoggedUser, removeReference, setLoggedUser} from "@/helpers";
import  {customToolbar} from "@/api/variables";
import LivraisonMode from "@/components/template/livraisons/livraison-mode";

export default {
  components: {
    LivraisonMode,
    formFile,
    saveBtnContainer,
    blinkiInputTxt,
    'editor': VueEditor,
    VueUploadMultipleImage
  },
  props: ['marque'],
  data() {
    return {
      id: -1,
      imgList: [],
      images: [],
      item_type: item_types.MARQUE,
      modalName: 'marque-update',
      cdnPath: process.env.CDN + 'marque/',
      customToolbar: customToolbar
    }
  },
  watch: {
    marque: {
      deep: true,
      handler: function (val) {
        if (val && val.marque_id !== this.id) {
          this.images = [];
          this.imgList = [];
          if (this.marque.image) {
            this.images.push({
              path: this.cdnPath + this.marque.image,
              default: 1,
              highlight: 1,
            });
          }
          this.id = val.marque_id;
        }
      },
    },
    close: {
      deep: true,
      handler: function (val, oldVal) {
        if (val) {
          this.$bvModal.hide(this.modalName);
          this.$bvModal.hide('confirm-store-modal');
        }
      },
    }
  },
  computed: {
    marqueRole(){
      let user = getLoggedUser();
      return user ? user.role === "MARQUE": false;
    },
    isFormValid() {
      return true;
    },
    isUpdate() {
      return !!this.marque.marque_id;
    },
    close() {
      return this.$store.state.marque.close;
    },
  },
  methods: {
    async baseToBlob(index) {
      this.imgList[index].blob = await (await fetch(this.imgList[index].path)).blob();
    },
    uploadImageSuccess(fd, index, fileList) {
      this.imgList = fileList;
      this.baseToBlob(index);
    },
    beforeRemove(index, done, fileList) {
      done();
    },
    editImage(fd, index, fileList) {
      console.log(fd,fileList[index].name);
      this.imgList = fileList;
      this.baseToBlob(index);
    },
    showToast(mssg, type){
      this.$toast.open({
        message: mssg,
        type: type ? type : 'error',
        duration: 4500
      });
    },
    onSubmit() {
      let action = null;
      let args = null;
      let PformData = new FormData();
      delete this.marque.image;
      if (this.imgList.length > 0 && !!this.imgList[0].blob)
        PformData.append('image', this.imgList[0].blob, this.imgList[0].name);
      PformData.append('nom', this.marque.nom);
      PformData.append('description', this.marque.description);
      PformData.append('titre', this.marque.titre);
      if (this.isUpdate) {
        action = 'marque/updateMarque';
        args = {
          id: this.marque.marque_id,
          formData: PformData
        };
      } else {
        action = 'marque/createMarque';
        args = PformData;
      }
      this.$store.dispatch(action, args)
        .then((response)=>{
          let user = getLoggedUser();
          if (user.role === 'MARQUE') {
            user.marque[0] = response;
            setLoggedUser(user);
          }
          this.showToast('Marque mise à jour avec succès', 'success');
        })
        .catch((err) => {
          if(err && err.message) {
            this.showToast(err.message, err.type);
          }
        });
    }
  }
}
</script>

<style scoped>
.marque-add /deep/ .blinki-input .no-dhtmlx {
  width: 100%;
}

.marque-add /deep/ .image-container, .marque-add /deep/ .image-upload {
  height: 100%;
}

.label {
  color: #ABABAB;
  font-size: 14px;
  font-weight: normal;
}
/deep/ .blinki-input-txt[disabled]{
  background-color: #80808024 !important;
  border-bottom: 0;
  border-radius: 4px;
  padding: 5px;
}
</style>
